import { memo } from 'react';

import { FileStatusIconErrored, FileStatusTitle } from '@air/feature-file-status/ui';

import { getTaskPaneFileStatusIconSize } from '~/components/FileStatusTrackingPane/getTaskPaneFileStatusIconSize';
import { PaneItemTW } from '~/components/FileStatusTrackingPane/PaneItemTW';
import { TaskPaneDismissButton } from '~/components/FileStatusTrackingPane/TaskPaneDismissButton';
import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type AssetCustomFieldValueUpdateTaskFailedPanelItemProps = {
  onClear: () => void;
};

export const AssetCustomFieldValueUpdateTaskFailedPanelItem = memo(
  ({ onClear }: AssetCustomFieldValueUpdateTaskFailedPanelItemProps) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    return (
      <PaneItemTW
        avatar={<FileStatusIconErrored size={getTaskPaneFileStatusIconSize(ui2026)} />}
        title={
          <FileStatusTitle data-testid="ASSET_CUSTOM_FIELD_VALUE_UPDATE_TASK_FAILED_PANEL_ITEM_TITLE">
            {ui2026 ? 'Couldn’t update custom fields' : 'Failed to update custom fields'}
          </FileStatusTitle>
        }
        buttons={<TaskPaneDismissButton label="Clear" onClick={onClear} />}
      />
    );
  },
);

AssetCustomFieldValueUpdateTaskFailedPanelItem.displayName = 'AssetCustomFieldValueUpdateTaskFailedPanelItem';
